import { styled } from 'styled-components';

export const SliderContent = styled.aside<{
  $collapsed: boolean;
  $panel: boolean;
}>`
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  background: #fff;

  ${({ $panel, $collapsed }) =>
    $panel
      ? `
    flex: 1 1 auto;
    width: 100%;
    min-height: 0;
    background: transparent;
  `
      : `
    flex: 0 0 ${$collapsed ? 50 : 250}px;
    height: 100%;
    transition: flex 0.3s;
  `}

  .ant-menu-inline-collapsed {
    width: 45px !important;
  }
`;

/** Fills space between header and version; menu scrolls inside so footer never overlaps items. */
export const SliderMenuWrap = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;

  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: ${({ theme }) => theme.accent};

    .ant-menu-item-icon {
      color: inherit;
    }
  }
`;

export const VersionText = styled.div<{ $collapsed: boolean }>`
  flex-shrink: 0;
  text-align: ${(p) => (p.$collapsed ? 'center' : 'right')};
  width: 100%;
  padding: 0 8px 4px;
  font-size: 12px;
  color: #888;
  opacity: 0.7;
  ${(p) =>
    p.$collapsed &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;
